import * as ms from 'milliseconds';
import { MBAnimation, MBAnimationProps } from './base';

// Note(fant): why from 0.01 ?
// On Android, setting scale to 0 has no effect; it renders as if the scale
// was set to 1. Setting the scale to 0.01 is a hacky workaround.
// For reference: https://github.com/facebook/react-native/issues/6278
export function MBAnimationBounceIn(props: MBAnimationProps) {
  return (
    <MBAnimation
      scale={{ from: 0.01, to: 1 }}
      duration={ms.seconds(0.2)}
      type="spring"
      {...props}
    />
  );
}
